<div cdkTrapFocus class="notification-overlay" *ngIf="notifications.showPanel" tabindex="0"  (keyup.enter)="close()" (click)="close()"></div>
<div cdkTrapFocus class="notification-panel" (keyup.escape) ="close()" *ngIf="notifications.showPanel">
    <div (keyup.escape) ="close()" class="notification-header">
        <div class="notification-header-title">
                <span class="tmi tmi-notification" style="font-size: 19px;padding-right: 5px;"></span>
                Notification Center
            <div>
                <div tabindex="0"  (keyup.escape) ="close()" id="crossIcon" (keyup.enter)="close()" (click)="close()" style="cursor: pointer;font-size: 15px;">x</div>
            </div>
        </div>
        <div class="notification-header-action-horizontal-line"></div>
        <div class="notification-header-action">
            <div class="row-1">
                    {{notifications?.notificationsList?.length}}&nbsp;NOTIFICATIONS
                <div  tabindex="0"   (keyup.escape) ="close()" (keyup.enter)="clearAll()" (click)="clearAll()" class="clearall">Clear all</div>
            </div>
        </div>
    </div>
    <div class="notification-body" cdkScrollBar>
        <ng-container *ngIf="notifications">
            <div class="notification-card" *ngFor="let notification of notifications?.notificationsList;let i = index;">
                <div  tabindex="0"  id="NotificationCard{{i}}"  (keyup.escape) ="close()" (keyup.enter)="navigateToWriteup(notification)" >
                <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;padding-right: 20px;">
                <div class="salesperson">
                    {{ 
                    (notification.customer.firstName + " " +notification.customer.lastName ).length > 16 
                ?   (notification.customer.firstName + " " +notification.customer.lastName ).substr(0,14)+ "..."
                :   (notification.customer.firstName + " " +notification.customer.lastName )
                    }}
                </div>
                <div tabindex="0"  (keyup.enter)="notifications?.notificationsList.splice($index, 1)" (click)="notifications?.notificationsList.splice($index, 1)" style="cursor: pointer;width: 10px;font-size: 15px;">x</div>
                </div>
                <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;padding-right: 20px;"  (click)="navigateToWriteup(notification)">

                <div class="notification-highlight">
                    {{notification.deal.salesPerson}}
                </div>
                <div class="updatedDate">{{notification.deal.updatedDate |  date: 'MM-dd-yyyy'}}</div>
                </div>
                    <div class="notification-body-action-horizontal-line"></div>
                <div class="notification-content"    (click)="navigateToWriteup(notification)">
                    <div class="writeupType">
                        {{notification.deal.writeupType | uppercase}}</div>
                    <div class="status">
                        {{notification.deal.status}}
                    </div>
                    <div class="onlineStatus">
                        <img style="padding-right: 5px; margin-bottom: -1.069px;" alt="online" src="{{darkTheme ? 'assets/images/online-status-icon-red-night.svg' : 'assets/images/online-status-icon-red-day.svg'}}">{{notification.deal.onlineStatus}}
                    </div>
                </div>
            </div>
        </div>
        </ng-container>
    </div>
</div>